import React, { FC, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import Clipboard from 'clipboard';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { useRestrictedModal } from '../../modal/useRestrictedModal';
import { TextButton } from '../../button';
import { useUser } from '../../../user/useUser';

type Props = {
  text: string;
  source: string;
  sendAnalytics: () => void;
};

export const ShareActionButton: FC<Props> = ({
  sendAnalytics,
  source,
  text,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!accessPremium) return;
    if (!buttonRef || !buttonRef.current) return;
    const clipboard = new Clipboard(buttonRef.current, {
      text: () => text,
    });
    return () => {
      clipboard.destroy();
    };
  }, []);

  const copyAndConfirm = () => {
    toast(
      <p>
        <FormattedMessage id="components/sub-header/actions/ShareActionButton.tsx/1" />
      </p>,
    );
    sendAnalytics();
  };

  const canUserCopy = accessPremium
    ? copyAndConfirm
    : () => openRestrictedModal({ source: `${source}_share` });

  return (
    <div
      data-multiline="true"
      data-tip="Copier la référence et le lien public"
      data-for="copy-reference-tooltip"
      data-place="bottom"
      data-effect="solid"
      data-delay-show="250"
      data-delay-hide="100"
      data-class="copy-button__tooltip"
      ref={buttonRef}
    >
      <TextButton type="button" onClick={canUserCopy} iconLeft="link">
        <FormattedMessage id="components/sub-header/actions/ShareActionButton.tsx/2" />
      </TextButton>
      <Tooltip id="copy-reference-tooltip" />
    </div>
  );
};
